import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withScriptjs, withGoogleMap, GoogleMap } from 'react-google-maps';
import MarkerClusterer from 'react-google-maps/lib/components/addons/MarkerClusterer';
import './Map.css';
import * as api from '../../../api';
import MapMarker from './MapMarker/MapMarker';
import { saveLastLocation } from '../../../redux/actions';

const MyMapComponent = withScriptjs(withGoogleMap(props => (
  <GoogleMap
    defaultZoom={7}
    options={{
      streetViewControl: false,
      clickableIcons: false,
      mapTypeControl: false,
      mapTypeId: 'hybrid',
      minZoom: 3,
      zoom: 7,
      center: {
        lat: 49.349852,
        lng: 17.850232,
      },
    }}
  >
    <MarkerClusterer
      averageCenter
      enableRetinaIcons
      gridSize={60}
    >
      {props.markers.map(markerData => (
        <MapMarker
          key={markerData[0]}
          markerData={markerData}
        />
      ))}
    </MarkerClusterer>
  </GoogleMap>
)));

// todo - show some 'fetching' state?
class Map extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: true,
      markers: [],
    };
  }

  componentDidMount() {
    // todo - not ideal to have scrolling scattered around - ideally make some "scroll" handler
    window.scrollTo(0, 0);
    // todo - also kind of weird - check implementation
    this.props.saveLastLocation(this.props.match.url);
    api.getMapMarkersData().then((data) => {
      this.setState({
        fetching: false,
        markers: data,
      });
    }).catch(() => {
      // todo - solve error state
    });
  }

  render() {
    return (
      <div>
        <div id="map-head">TOTO100LETÍ NA MAPĚ</div>
        <MyMapComponent
          markers={this.state.markers}
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDTkV6VUT7BpuPJHXRzbihhiuP1MTr8q0Q&v=3.exp&libraries=geometry,drawing,places"
          loadingElement={<div style={{ height: '100%' }} />}
          containerElement={<div className={`map-frame-cont ${this.props.menuOverlay ? 'small' : ''}`} />}
          mapElement={<div id="detail-map" />}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  menuOverlay: state.resize.menuOverlay,
});

const mapDispatchToProps = dispatch => ({
  saveLastLocation: lastLocation => dispatch(saveLastLocation(lastLocation)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Map);



// WEBPACK FOOTER //
// ./src/components/App/Map/Map.js